// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SendSMSAssetsManager from "../assets/SendSMSAssetsManager.bs.js";

var error_icon = SendSMSAssetsManager.getImage("error-icon.svg");

function ErrorViewCmp(Props) {
  var message = Props.message;
  return React.createElement("div", {
              className: "send-sms-error-container"
            }, React.createElement("div", {
                  className: "error-img"
                }, React.createElement("img", {
                      src: error_icon
                    })), React.createElement("div", {
                  className: "error-text"
                }, message));
}

var make = ErrorViewCmp;

export {
  error_icon ,
  make ,
  
}
/* error_icon Not a pure module */
